import { VirtualTableHeadCell } from '../../virtualized-table/types';

import { SelectColumnFilter } from '../../virtualized-table/components/filter';
import CustomButton from "./custom-button";
import CustomEntitlement from "./custom-entitlement";

export const tableHeadCells: VirtualTableHeadCell[] = [
    {
        accessor: 'firstName',
        Header: 'First Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'lastName',
        Header: 'Last Name',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'email',
        Header: 'Email',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'username',
        Header: 'Username',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'entitlements',
        Header: 'Entitlements',
        Filter: SelectColumnFilter,
        filter: 'textAndCheckbox',
    },
    {
        accessor: 'lastLoginTime',
        Header: 'Last Login',
    },
    {
        accessor: 'createdTime',
        Header: 'Created Time',
    },
    {
        accessor: 'catrecid',
        Header: 'Revoke Action',
        component: CustomButton,
    },
];

export const tableSortableAccessors = {
    firstName: false,
    lastName: false,
    email: false,
    username: false,
    lastLoginTime: true,
    createdTime: true,
    entitlements: false,
    catrecid: false,
};